import { IconButton } from "@mui/material";
import NotesIcon from '@mui/icons-material/Notes';
import { useState } from "react";
import Draggable from "react-draggable"
import MinimizeIcon from '@mui/icons-material/Minimize';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const TCNDialerComponent: React.FC = () => {
	const [dragging, setDragging] = useState(false);
	const [isMinimized, minimize] = useState(false);
	const [showNotePopup, setShowNotePopup] = useState(false);

	const tcnAgentMapping = useSelector((state: RootState) => state.dialerState.tcn_agent);

	return (
		<>
			<Draggable
				handle=".drag-handle"
				onStart={() => setDragging(true)}
				onStop={() => setDragging(false)}
			>
				<div
					style={{
						width: 360,
						height: isMinimized ? 157 : 360,
						position: 'absolute',
						left: '110px',
						bottom: '0px',
						border: "2px solid #180404ff",
						borderRadius: "8px",
						zIndex: 10000,
						transform: "translate3d(0,0,0)",
						willChange: "transform",
						cursor: dragging ? "grabbing" : "grab",
						userSelect: "none",
					}}
				>
					<div
						className="drag-handle"
						style={{
							display: 'flex', // Enable Flexbox
							justifyContent: 'space-between', // Push content to ends
							alignItems: 'center', // Vertically center items
							background: "#333",
							color: "white",
							padding: "8px",
							cursor: "move",
							userSelect: "none",
							height: 10, // Original height
						}}
					>
						<div style={{ marginLeft: '4px' }}>Dialer</div> {/* Slight padding for text */}

						<div style={{ display: 'flex', alignItems: 'center' }}>
							{/* 1. New Note Icon Button */}
							<IconButton
								size="small"
								onClick={() => setShowNotePopup(prev => !prev)} // Toggle popup state
								// We don't want the drag handle to interfere with click events
								// but the mouse move is fine.
								onMouseDown={(e) => e.stopPropagation()} // Prevent drag start on button click
								style={{ color: 'white', padding: '0 4px', cursor: 'pointer' }}
								aria-label="Toggle Notes"
							>
								<NotesIcon fontSize="small" />
							</IconButton>
							{/* 2. MUI IconButton for Minimize/Maximize Logic */}
							<IconButton
								size="small"
								onClick={() => minimize(!isMinimized)}
								style={{ color: 'white', padding: '0 4px' }} // Custom styles for small, white icon
								aria-label={isMinimized ? "Maximize" : "Minimize"}
							>
								{isMinimized ? (
									<OpenInFullIcon fontSize="small" /> // Show Maximize when MINIMIZED
								) : (
									<MinimizeIcon fontSize="small" /> // Show Minimize when MAXIMIZED
								)}
							</IconButton>
						</div>
					</div>
					{showNotePopup && (
						<div
							style={{
								position: 'absolute',
								top: '42px', // Position below the header (approx. 26px header + margin)
								right: '10px', // Align to the right of the window
								width: '250px',
								padding: '10px',
								background: '#FFFFE0', // Light yellow background for a 'note' look
								color: '#333',
								border: '1px solid #E0E0A0',
								borderRadius: '4px',
								boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
								zIndex: 10001, // Ensure it's above the iframe/content
								userSelect: 'text', // Allow text selection in the popup
							}}
						>
							<strong>Billing Id: {tcnAgentMapping?.billing_id}</strong>
							<br/>
							<strong>Username: {tcnAgentMapping?.agent_username}</strong>
							<br/>
							<strong>Password: {tcnAgentMapping?.agent_password}</strong>
						</div>
					)}
					{tcnAgentMapping != null ?
						<div
							style={{
								width: 370,
								height: isMinimized ? 176 : 380, // The window size for the content
								overflow: 'hidden',     // HIDES the cropped content
								position: 'absolute',   // Necessary for absolute positioning of iframe
							}}
						>
							{/* 3. The IFRAME (Handles shifting/cropping) */}
							<iframe
								src="https://operator.tcn.com/"
								style={{
									// Set the iframe size to the calculated content size
									width: 410,
									height: isMinimized ? 176 : 380,

									// CRITICAL: Absolute position and shift
									position: 'absolute',
									top: `-45px`, // Shifts content UP (hides header)
									left: `-50px`, // Shifts content LEFT (hides sidebar)

									border: "none",
									pointerEvents: dragging ? "none" : "auto",
								}}
								allow="microphone"
								title="TCN Cropped Iframe"
							/>
						</div> :
						<div style={{
							margin: '20px',
							display: 'flex',              // Enable Flexbox
							justifyContent: 'center',     // Center content horizontally
							alignItems: 'center',
							// width: 370,
							// height: isMinimized ? 176 : 380,
							// --- Background Fix ---
							backgroundColor: '#F7F7F7',   // Off-white color
							padding: '10px',              // Added padding for visual appeal
							borderRadius: '4px',          // Optional: slight rounding
							textAlign: 'center',
						}}>
							<span>No dialer credentials mapped to this account. Talk to your admin.</span>
						</div>
					}
				</div>
			</Draggable>
		</>
	)
}
export default TCNDialerComponent;